import { capitalCase, } from 'filters/capitalCase'
import { defaultGamerProfile, } from 'const/gamerProfiles'
import { modeFreeCategories, } from 'const/simulator'
import { rewardSounds, } from 'const/sounds'
import A from 'const/actionTypes'
import actions from '.'
import firebaseService from 'infrastructure/FirebaseService'
import N from 'const/namespace'
import store from 'store'

const alertGamerFromScore = (gameInterface, newProfileData, oldProfileData) => {
  const category = gameInterface.category
  const mode = gameInterface.mode
  const newModeData = modeFreeCategories.includes(category) ?
    newProfileData[category] || {} :
    newProfileData[category][mode] || {}
  const oldModeData = modeFreeCategories.includes(category) ?
    oldProfileData[category] || {} :
    oldProfileData[category][mode] || {}

  let message

  if (category === 'counter-strike-global-offensive') {
    const packHighScore = gameInterface.pack.substring(0, gameInterface.pack.length - 1) + 'HighScore'
    const weaponHighScore = gameInterface.weapon + 'HighScore'

    if (newModeData.highScore > oldModeData.highScore) {
      message = 'New CS:GO High Score'
    } else if (newModeData[packHighScore] > oldModeData[packHighScore]) {
      message = 'New CS:GO ${gameInterface.pack.toUpperCase()} High Score'
    } else if (newModeData[weaponHighScore] > oldModeData[weaponHighScore]) {
      message = 'New CS:GO ${gameInterface.weapon.toUpperCase()} High Score'
    } else {
      message = "Don't Let the Terrorists Win!"
    }
  } else if (newProfileData.highScore > oldProfileData.highScore) {
    message = 'New Overall High Score'
  } else if (newProfileData.topSpeed > oldProfileData.topSpeed) {
    message = 'New Overall Top Speed'
  } else if (newProfileData.topScaleSpeed > oldProfileData.topScaleSpeed) {
    message = 'New Overall Top Scaling Speed'
  } else if (newProfileData.topAccuracy > oldProfileData.topAccuracy) {
    message = 'New Overall Accuracy Best'
  } else if (newProfileData.longestHitStreak > oldProfileData.longestHitStreak) {
    message = 'New Overall Longest Hit Streak'
  } else if (newModeData.highScore > oldModeData.highScore) {
    message = `New ${capitalCase(category)} ${capitalCase(mode)} High Score`
  } else if (newModeData.topSpeed > oldModeData.topSpeed) {
    message = `New ${capitalCase(category)} ${capitalCase(mode)} Top Speed`
  } else if (newModeData.topScaleSpeed > oldModeData.topScaleSpeed) {
    message = `New ${capitalCase(category)} ${capitalCase(mode)} Top Scaling Speed`
  } else if (newModeData.topAccuracy > oldModeData.topAccuracy) {
    message = `New ${capitalCase(category)} ${capitalCase(mode)} Accuracy Best`
  } else if (newModeData.longestHitStreak > oldModeData.longestHitStreak) {
    message = `New ${capitalCase(category)} ${capitalCase(mode)} Longest Hit Streak`
  } else {
    message = null
  }

  let shareMessage, sound, title

  if (category === 'counter-strike-global-offensive') {
    message = 'Keep training to become the best CS:GO player!'
    shareMessage = `CS:GO players, can you beat my high score? ${newModeData.highScore}% #CSGO`
    sound = rewardSounds.positive
    title = message
  } else if (category === 'ranked' && newModeData.topSpeed > oldModeData.topSpeed) {
    message = "You've earned a new high score in the Gauntlet. Check your position on the Leaderboard!"
    shareMessage = `Can you beat my new high score? ${newModeData.topSpeed * 1000}`
    sound = rewardSounds.positive
    title = 'NEW HIGH MMR!'
  } else if (gameInterface.accuracy === 1) {
    message = 'Nice Shooting!'
    shareMessage = `I never miss a shot! ${gameInterface.targetCount} in a row!`
    sound = rewardSounds.flawless
    title = 'FLAWLESS VICTORY!'
  } else if (message) {
    message = message
    shareMessage = 'My aim is improving! How about yours?'
    sound = rewardSounds.positive
    title = 'IMPROVEMENT!'
  } else {
    message = '5 minutes a day improves your gameplay!'
    shareMessage = 'NetPlay - where gamers go to train.'
    sound = rewardSounds.negative
    title = 'PRACTICE MAKES PERFECT!'
  }

  let rejectCallback, rejectCaption, tertiaryCallback, tertiaryCaption

  if (gameInterface.category === 'ranked') {
    rejectCallback = () => {
      store.dispatch(actions.routeTo('leaderboard'))
    }
    rejectCaption = 'Leaderboards'
    tertiaryCallback = () => {
      store.dispatch(actions.routeTo('bootcamp'))
    }
    tertiaryCaption = 'Bootcamp'
  } else if (gameInterface.category === 'practice') {
    rejectCallback = () => {
      store.dispatch(actions.routeTo('gauntlet'))
    }
    rejectCaption = 'The Gauntlet'
    tertiaryCallback = () => {
      store.dispatch(actions.routeTo('custom-games'))
    }
    tertiaryCaption = 'Custom'
  } else {
    rejectCallback = () => {
      store.dispatch(actions.routeTo('gauntlet'))
    }
    rejectCaption = 'The Gauntlet'
    tertiaryCallback = () => {
      store.dispatch(actions.routeTo('bootcamp'))
    }
    tertiaryCaption = 'Bootcamp'
  }

  store.dispatch(actions.showDialog({
    acceptCallback: () => {},
    acceptCaption: 'Continue',
    content: message,
    largeText: true,
    postGameStatistics: true,
    rejectCallback: rejectCallback,
    rejectCaption: rejectCaption,
    shareMessage: shareMessage,
    sound: sound,
    tertiaryCallback: tertiaryCallback,
    tertiaryCaption: tertiaryCaption,
    title: title,
  }))
}

const markInitialDialogAsShown = () => {
  store.dispatch(actions.updateCurrentGamerTour({ initialDialogShown: true, }))
}

const notifyNewUser = (dispatch, getState) => {
  dispatch(actions.showDialog({
    acceptCallback: () => {
      store.dispatch(actions.routeTo('gauntlet'))
    },
    acceptCaption: 'The Gauntlet',
    content: `Visit the Tutorial to learn the basics.
      Choose Bootcamp for targets that learn from you.
      Pick the Gauntlet to earn a spot on the leaderboard!`,
    fontIcon: 'fa-star',
    largeText: true,
    rejectCallback: () => {
      store.dispatch(actions.routeTo('bootcamp'))
    },
    rejectCaption: 'Bootcamp',
    sound: rewardSounds.positive,
    tertiaryCallback: () => {
      store.dispatch(actions.routeTo('learning'))
    },
    tertiaryCaption: 'Tutorial',
    title: 'Welcome to NetPlay!',
  }))
  markInitialDialogAsShown()
}

const updateProfileData = (gameInterface, mode, modeData, oldProfileData) => {
  const newHighScore = Math.max(gameInterface.score, modeData.highScore || 0)
  const newLongestHitStreak = Math.max(gameInterface.longestHitStreak, modeData.longestHitStreak || 0)
  const newTopAccuracy = Math.max(gameInterface.accuracy, modeData.topAccuracy || 0)
  const newTopMissCount = Math.max(gameInterface.missCount, modeData.topMissCount || 0)
  const newTopMissedTargetCount = Math.max(gameInterface.missedTargetCount, modeData.topMissedTargetCount || 0)
  const newTopSpeed = Math.max(gameInterface.speed, modeData.topSpeed || 0)
  const newTopScaleSpeed = Math.max(gameInterface.scaleSpeed, modeData.topScaleSpeed || 0)
  const newTopTargetCount = Math.max(gameInterface.targetCount, modeData.topTargetCount || 0)

  let newModeData = {
    acceleration: gameInterface.acceleration,
    goal: gameInterface.goal,
    goalType: gameInterface.goalType,
    highScore: newHighScore,
    longestHitStreak: newLongestHitStreak,
    scale: gameInterface.scale,
    scaleSpeed: gameInterface.scaleSpeed,
    speed: gameInterface.speed,
    topAccuracy: newTopAccuracy,
    topMissCount: newTopMissCount,
    topMissedTargetCount: newTopMissedTargetCount,
    topSpeed: newTopSpeed,
    topScaleSpeed: newTopScaleSpeed,
    topTargetCount: newTopTargetCount,
  }

  let newProfileData = {
    highScore: Math.max(newHighScore, oldProfileData.highScore),
    longestHitStreak: Math.max(newLongestHitStreak, oldProfileData.longestHitStreak),
    topAccuracy: Math.max(newTopAccuracy, oldProfileData.topAccuracy),
    topMissCount: Math.max(newTopMissCount, oldProfileData.topMissCount),
    topMissedTargetCount: Math.max(newTopMissedTargetCount, oldProfileData.topMissedTargetCount),
    topScaleSpeed: Math.max(newTopScaleSpeed, oldProfileData.topScaleSpeed),
    topSpeed: Math.max(newTopSpeed, oldProfileData.topSpeed),
    topTargetCount: Math.max(newTopTargetCount, oldProfileData.topTargetCount),
  }

  if (gameInterface.category === 'ranked') {
    newProfileData = Object.assign({}, oldProfileData, newProfileData)
    newProfileData.ranked = Object.assign({}, oldProfileData.ranked || {}, newModeData)
  } else if (gameInterface.category === 'custom') {
    newProfileData = Object.assign({}, oldProfileData, newProfileData)
    newProfileData.custom = Object.assign({}, oldProfileData.custom || {}, newModeData)
  } else if (gameInterface.category === 'flick') {
    newProfileData = Object.assign({}, oldProfileData, newProfileData)
    newProfileData.flick = Object.assign({}, oldProfileData.flick || {}, newModeData)
  } else if (gameInterface.category === 'follow-through') {
    newProfileData = Object.assign({}, oldProfileData, newProfileData)
    newProfileData['follow-through'] = Object.assign({}, oldProfileData['follow-through'] || {}, newModeData)
  } else if (gameInterface.category === 'net-train') {
    newProfileData = Object.assign({}, oldProfileData, newProfileData)
    newProfileData['net-train'] = Object.assign({}, oldProfileData['net-train'] || {}, newModeData)
  } else if (gameInterface.category === 'speed') {
    newProfileData = Object.assign({}, oldProfileData, newProfileData)
    newProfileData.speed = Object.assign({}, oldProfileData.speed || {}, newModeData)
  } else if (gameInterface.category === 'tracking') {
    newProfileData = Object.assign({}, oldProfileData, newProfileData)
    newProfileData.tracking = Object.assign({}, oldProfileData.tracking || {}, newModeData)
  } else if (gameInterface.category === 'zig-zag') {
    newProfileData = Object.assign({}, oldProfileData, newProfileData)
    newProfileData['zig-zag'] = Object.assign({}, oldProfileData['zig-zag'] || {}, newModeData)
  } else if (gameInterface.category === 'practice') {
    newProfileData = Object.assign({}, oldProfileData, newProfileData)
    newProfileData.practice[mode] = Object.assign({}, oldProfileData.practice[mode] || {}, newModeData)
  } else if (gameInterface.category === 'learning') {
    newProfileData = Object.assign({}, oldProfileData, newProfileData)
    newProfileData.learning[mode] = Object.assign({}, oldProfileData.learning[mode] || {}, newModeData)
  }

  alertGamerFromScore(gameInterface, newProfileData, oldProfileData)
  return newProfileData
}

const updateProfileDataForCSGO = (gameInterface, modeData, oldProfileData) => {
  const newGunHighScore = Math.max(
    gameInterface.score,
    modeData[gameInterface.weapon + 'HighScore'] || 0
  )
  const newHighScore = Math.max(
    gameInterface.score,
    modeData.highScore || 0
  )
  const newPackHighScore = Math.max(
    gameInterface.score,
    modeData[gameInterface.pack.substring(0, gameInterface.pack.length - 1) + 'HighScore'] || 0
  )

  let newModeData = {
    highScore: newHighScore,
    [gameInterface.pack.substring(0, gameInterface.pack.length - 1) + 'HighScore']: newPackHighScore,
    [gameInterface.weapon + 'HighScore']: newGunHighScore,
  }

  let newProfileData = {
    highScore: Math.max(newHighScore, oldProfileData.highScore || 0),
  }

  newProfileData = Object.assign({}, oldProfileData, newProfileData)
  newProfileData['counter-strike-global-offensive'] = Object.assign(
    defaultGamerProfile['counter-strike-global-offensive'],
    oldProfileData['counter-strike-global-offensive'] || {},
    newModeData
  )

  alertGamerFromScore(gameInterface, newProfileData, oldProfileData)
  return newProfileData
}

const updateStatistics = (gameInterface, oldProfileData) => {
  const category = gameInterface.category
  const mode = gameInterface.mode
  const modeData = modeFreeCategories.includes(category) ?
    oldProfileData[category] || defaultGamerProfile[category] :
    oldProfileData[category][mode] || defaultGamerProfile[category][mode]

  let newProfileData

  if (category === 'counter-strike-global-offensive') {
    newProfileData = updateProfileDataForCSGO(
      gameInterface,
      modeData,
      oldProfileData
    )
  } else {
    newProfileData = updateProfileData(
      gameInterface,
      mode,
      modeData,
      oldProfileData
    )
  }

  return newProfileData
}

export default {
  clearCurrentGamerProfile: () => {
    return (dispatch, getState) => {
      dispatch({ type: A.CLEAR_CURRENT_GAMER_PROFILE, })
    }
  },
  createCurrentGamerProfile: (gamerId) => {
    return (dispatch, getState) => {
      dispatch({
        type: A.CREATE_CURRENT_GAMER_PROFILE,
        defaultGamerProfile,
      })
      firebaseService.add(
        'gamerProfiles/',
        defaultGamerProfile,
        N.GAMERS,
        gamerId
      )
    }
  },
  deleteCurrentGamerProfile: (gamerId) => {
    return (dispatch, getState) => {
      firebaseService.off('gamerProfiles/' + gamerId, N.GAMERS)
      dispatch({ type: A.DELETE_CURRENT_GAMER_PROFILE, })
    }
  },
  setCurrentGamerProfile: (gamerId) => {
    return (dispatch, getState) => {
      // TODO - check verified status
      // const gamer = getState().currentGamer
      // const verified = gamer.verified || gamer.initialProvider !== 'password'

      firebaseService.subscribe(
        'gamerProfiles/' + gamerId,
        (result) => {
          let currentGamerProfile = result.val()

          if (!currentGamerProfile) {
            dispatch(actions.createCurrentGamerProfile(gamerId))
            currentGamerProfile = defaultGamerProfile
          }

          dispatch({
            type: A.SET_CURRENT_GAMER_PROFILE,
            currentGamerProfile
          })

          if (!currentGamerProfile.tour.initialDialogShown) { // TODO add && verified
            notifyNewUser(dispatch, getState)
          }
        },
        N.GAMERS
      )
    }
  },
  toggleOverlay: () => {
    return (dispatch, getState) => {
      let updatedSettings = {
        mouseoverOverlay: !getState().currentGamerProfile.mouseoverOverlay,
      }

      dispatch(actions.updateCurrentGamerProfile(updatedSettings))
    }
  },
  toggleAchievementSounds: () => {
    return (dispatch, getState) => {
      let updatedSettings = {
        achievementSoundsEnabled: !getState().currentGamerProfile.achievementSoundsEnabled,
      }

      dispatch(actions.updateCurrentGamerProfile(updatedSettings))
    }
  },
  toggleSound: () => {
    return (dispatch, getState) => {
      let updatedSettings = {
        soundEnabled: !getState().currentGamerProfile.soundEnabled,
      }

      dispatch(actions.updateCurrentGamerProfile(updatedSettings))
    }
  },
  updateCurrentGamerCustomGamesProfile: (newCustomGamesProfile) => {
    return (dispatch, getState) => {
      const currentGamerProfile = getState().currentGamerProfile || defaultGamerProfile
      const currentCustomGamesProfile = currentGamerProfile.custom || defaultGamerProfile.custom

      let updatedCustomGamesProfile = Object.assign(
        {},
        currentCustomGamesProfile,
        newCustomGamesProfile
      )

      dispatch(actions.updateCurrentGamerProfile({ custom: updatedCustomGamesProfile }))
    }
  },
  updateCurrentGamerProfile: (newCurrentGamerProfile) => {
    return (dispatch, getState) => {
      let gamerId = getState().auth.uid
      let currentGamerProfile = getState().currentGamerProfile || defaultGamerProfile
      let updatedCurrentGamerProfile = Object.assign(
        defaultGamerProfile, currentGamerProfile, newCurrentGamerProfile
      )

      dispatch({
        type: A.UPDATE_CURRENT_GAMER_PROFILE,
        updatedCurrentGamerProfile,
      })

      firebaseService.update(
        'gamerProfiles/' + gamerId,
        updatedCurrentGamerProfile,
        (error) => {
          if (error) { dispatch(actions.alertGamerWithError(error)) }
        },
        N.GAMERS,
      )
    }
  },
  updateCurrentGamerProfileWithScore: () => {
    return (dispatch, getState) => {
      let updatedGamerProfile = Object.assign({}, getState().currentGamerProfile)

      updatedGamerProfile = updateStatistics(
        getState().gameInterface,
        updatedGamerProfile
      )

      dispatch(actions.updateCurrentGamerProfile(updatedGamerProfile))
    }
  },
  updateCurrentGamerTour: (tourUpdate) => {
    return (dispatch, getState) => {
      const tour = getState().currentGamerProfile.tour
      const updatedTour = Object.assign({}, tour, tourUpdate)
      dispatch(actions.updateCurrentGamerProfile({ tour: updatedTour, }))
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/actions/currentGamerProfile.js